var _path, _g, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 77",
    width: 64,
    height: 77,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.388 68.04H2.56V13H12.8v2.56a1.28 1.28 0 0 0 1.28 1.28h20.48a1.28 1.28 0 0 0 1.28-1.28V13h10.24v28.16a1.28 1.28 0 0 0 2.56 0V11.72a1.28 1.28 0 0 0-1.28-1.28H35.84V7.88a1.28 1.28 0 0 0-1.28-1.28h-3.84a6.41 6.41 0 0 0-6.4-6.4 6.41 6.41 0 0 0-6.4 6.4h-3.84a1.28 1.28 0 0 0-1.28 1.28v2.56H1.28A1.28 1.28 0 0 0 0 11.72v57.6a1.28 1.28 0 0 0 1.28 1.28h29.108a1.28 1.28 0 0 0 0-2.56zM24.32 2.76c2.117 0 3.84 1.722 3.84 3.84h-7.68c0-2.118 1.722-3.84 3.84-3.84zm-8.96 6.4h17.92v5.12H15.36V9.16zm32 34.56c-9.176 0-16.64 7.464-16.64 16.64S38.184 77 47.36 77 64 69.536 64 60.36s-7.464-16.64-16.64-16.64zm0 30.72a14.1 14.1 0 0 1-14.08-14.08 14.1 14.1 0 0 1 14.08-14.08 14.1 14.1 0 0 1 14.08 14.08 14.1 14.1 0 0 1-14.08 14.08z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.93 53.072c-.295-.295-.774-.295-1.07 0L40.072 66.86c-.295.295-.295.774 0 1.07.148.148.34.22.535.22s.387-.074.535-.22L54.93 54.14c.295-.295.295-.774 0-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.93 66.86c.295.295.295.774 0 1.07-.148.148-.34.22-.535.22s-.387-.074-.535-.22L40.07 54.14c-.295-.295-.295-.774 0-1.07M54.93 66.86L40.07 53.072M54.93 66.86L41.14 53.072M54.93 66.86L41.14 53.072m-1.07 0c.295-.295.774-.295 1.07 0m-1.07 0h1.07m0 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96 52.68a1.28 1.28 0 0 0 0 2.56h19.02a1.28 1.28 0 0 0 0-2.56H8.96zM34.573 45a1.28 1.28 0 0 0-1.28-1.28H8.96a1.28 1.28 0 0 0 0 2.56h24.333a1.28 1.28 0 0 0 1.28-1.28zm6.387-8.96a1.28 1.28 0 0 0-1.28-1.28H8.96a1.28 1.28 0 0 0 0 2.56h30.72a1.28 1.28 0 0 0 1.28-1.28zM39.68 25.8H8.96a1.28 1.28 0 0 0 0 2.56h30.72a1.28 1.28 0 0 0 0-2.56z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 53h15v15H40z"
  })))));
}

export default __webpack_public_path__ + "media/373cc976.svg";
export { SvgFormError as ReactComponent };